import { IntegrationUpsert } from 'models/integrations'
import api from '../..'

export const testAuth = ({
  ...data
}: IntegrationUpsert) => {
  return api.post('integrations/coursera/test_coursera', data)
    .then((response) => response)
}

export default testAuth
